import { isMaintenance503Payload } from '@/utils/maintenance/isMaintenance503Payload';
import { redirectToMaintenancePage } from '@/utils/maintenance/redirectToMaintenancePage';

export function handleMaintenanceHttpError(status: number, body: unknown): boolean {
  if (status !== 503 || !isMaintenance503Payload(body)) {
    return false;
  }

  redirectToMaintenancePage();
  return true;
}
